var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "row3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nav:2_1_",
    d: "M110.5 12.7c-9.7 0-17.5 7.7-17.5 17.1 0 4.2 5.2 13.1 5.2 13.1l8.8 14.5c-13.2.8-33.4 7.5-34 28.9-.1 4.9-2 8.9-5.7 12.3-10.5 9.7-32.5 10.9-40.6 11l12.5-21.8s8-12.1 8-17.7c0-12.8-10.6-23.2-23.7-23.2C10.6 46.9 0 57.3 0 70.1c0 5.7 7.1 17.7 7.1 17.7L23.6 115v.3H26c7.9 0 32.8-1 45.3-12.5 4.8-4.4 7.3-9.9 7.5-16.3.6-23.2 29.1-23.6 31.7-23.5h.1l.1-.1 11.5-20s5.9-8.9 5.9-13.1c-.1-9.4-7.9-17.1-17.6-17.1zM23.7 82c-7.7 0-14-6.1-14-13.6s6.3-13.7 14-13.7 14 6.1 14 13.7c0 7.5-6.3 13.6-14 13.6zm86.8-43.4c-5.7 0-10.3-4.5-10.3-10.1s4.6-10.1 10.3-10.1c5.7 0 10.3 4.5 10.3 10.1s-4.6 10.1-10.3 10.1z",
    fill: "var(--icon-fill, #191919)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripIcon);
export default __webpack_public_path__ + "static/media/trip-icon.ce942ee3745a7d275812eea509256ea8.svg";
export { ForwardRef as ReactComponent };